import { Pricing } from '@/components/pricing/Pricing';
import React from 'react';

export default function _Pricing() {
  return <Pricing />;
}
